(function ($) {
    /**
     * SC ACCORDION
     */

    function scAccordionToggle() {
        var blockClickableArea = $('.sc-accordion__block-title');

        blockClickableArea.on('click', function() {
            var contentBlock = $(this).parent().find('.sc-accordion__block-content');
            var parentBlock = $(this).parent();

            parentBlock.toggleClass('open');

            var contentBlockHeight = contentBlock.prop('scrollHeight') + 25 + 'px';

            if ( parentBlock.hasClass('open') ) {
                contentBlock.animate({ 'max-height' : contentBlockHeight }, 50);
            } else {
                contentBlock.animate({ 'max-height' : null }, 50);
            }
        });
    }



    function initSCAccordion() {
        var scAccordion = $('.sc-accordion');

        scAccordion.addClass('loaded');

        scAccordionToggle();
    }

    function initHomeHero() {
        var playButton = $('.sc-home-hero-block__play_button');
        var closeButton = $('.sc-home-hero-block__close-sequence');

        playButton.on('click', function(){
            $(this).parent().parent().parent().find('.sc-home-hero-block__sequence').addClass('open');
        });

        closeButton.on('click', function(){
            $(this).parent().removeClass('open');
        });
    }

    /**
     * Anchor menu item to price block. Slide in anter click
     */
    function initPriceAnchor() {
        var menuItem = $('.sc-pricing');

        if (menuItem.length > 0) {
            menuItem.each(function(){
                $(this).on('click', function(){
                    slideToPricing();
                });
            })
        }
    }

    /**
     * Slide to pricing block with animation
     */
    function slideToPricing() {
        var priceBlock = $('.sc-plan-and-pricing');

        if (priceBlock.length > 0) {
            $('html, body').stop().animate({
                scrollTop: priceBlock.offset().top - 150
            }, 1000);
        }
    }

    /**
     * Search for pricing hash and navigate to pricing block if hash exists
     */
    function searchForPriceUrlPath() {
        //console.log('window.location.hash',  window.location.hash);
        var hash = window.location.hash;

        if (hash === '#pricing') {
            slideToPricing();
        }
    }

    function initBlocksJs() {
        searchForPriceUrlPath();
        initHomeHero();
        initSCAccordion();
        initPriceAnchor();
    }

    $('.sc-home-hero-block__content-toggle-wrapper').on('click', function(){
        $(this).parent().parent().find('.sc-home-hero-block__content-wrapper').toggleClass('open');
    });


    initBlocksJs();

})(jQuery);
